import { render, staticRenderFns } from "./comWageGz.vue?vue&type=template&id=380e4d5a&scoped=true&"
import script from "./comWageGz.vue?vue&type=script&lang=js&"
export * from "./comWageGz.vue?vue&type=script&lang=js&"
import style0 from "./comWageGz.vue?vue&type=style&index=0&id=380e4d5a&scoped=true&lang=css&"
import style1 from "./comWageGz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e4d5a",
  null
  
)

export default component.exports